import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigationAppBar } from 'src/common/components/AppLayout/AppNavigation/Components/NavigationAppBar';
import { TablePageTitle } from 'src/common/components/AppLayout/TablePage/TablePageTitle';
import { SomethingWentWrongErrorBoundary } from 'src/common/components/Fallbacks/SomethingWentWrongErrorBoundary';
import { LocationsAccountSelect } from 'src/locations/LocationsAccountSelect';
import { LocationsDashboardBanner } from 'src/locations/LocationsDashboardBanner';
import { LocationsFilters } from 'src/locations/LocationsFilters';
import { LocationsGraph } from 'src/locations/LocationsGraph';
import { LocationsMapSection } from 'src/locations/LocationsMapSection';
import { LocationsStats } from 'src/locations/LocationsStats';
import { LocationsURLParser } from 'src/locations/LocationsURLParser';

export const LocationsPage: FC = () => {
  const { t } = useTranslation();

  return (
    <LocationsURLParser>
      <SomethingWentWrongErrorBoundary>
        <NavigationAppBar
          title={<TablePageTitle>{t('locations.title')}</TablePageTitle>}
          middleContent={<LocationsAccountSelect />}
        />
        <Stack spacing={12} pb={12}>
          <LocationsDashboardBanner />
          <LocationsFilters />
          <LocationsStats />
          <Grid container columns={2} spacing={12}>
            <Grid size={1}>
              <LocationsGraph />
            </Grid>
            <Grid size={1}>
              <LocationsMapSection />
            </Grid>
          </Grid>
        </Stack>
      </SomethingWentWrongErrorBoundary>
    </LocationsURLParser>
  );
};
